import React from 'react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { authenticated } from '../../components/hocs/authenticated';
import './coursePack.module.scss';
import RoleModelCard1 from './images/shares-4930159.png';
import PatternLeft from './images/pattern-left-blue.png';
import PatternRight from './images/pattern-right-blue.png';
import SheHirameki from './images/she-hirameki.png';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import classNames from 'classnames';
import {
  CourseMarketingFirstCard,
  CourseSmallSelfBrandingCard,
  CourseWebDesignFirstCard,
  CourseWritingFirstCard,
} from './CourseCard';
import { V3Routes } from '../../routes';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';

@withNavigation(NavigationSpecs.side())
@authenticated
export class PopularPage extends React.Component {
  render() {
    const breadCrumbItems = [{ text: 'コース', to: V3Routes.courses() }, { text: '人気コースセット' }];
    return (
      <>
        <div styleName={classNames('head', 'popular')}>
          <div styleName="head-inner">
            <BreadCrumb items={breadCrumbItems} hasHome />
            <div styleName="head-content">
              <div styleName={classNames('course-title', 'popular')}>人気コースセット</div>
              <div styleName="head-detail">
                <div styleName="description">
                  「自分に向いていることを見つけたい」「好きなことを探したい」という方にまず取り組んでいただきたいコースを集めたセットです。SHElikesの数あるコースの中でも特に人気・主要なコースから学習を始めて、やりたいことやなりたい姿を探していきましょう。
                </div>
                <div styleName={classNames('comment', 'popular')}>
                  <div styleName="label-box">
                    <div styleName={classNames('label', 'popular')}>こんなひとにおすすめ</div>
                  </div>
                  <img src={SheHirameki} styleName="she-image" />
                  <ul styleName="comment-text">
                    <li>まずは基礎知識を身につけたい</li>
                    <li>自分の好きや得意を探したい</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div styleName={classNames('content-bg', 'popular')}>
          <div styleName="content">
            <p styleName="title">必修コース</p>
            <p styleName="sub-title">必ず受けておきたいコース</p>
            <div styleName="main-course-list">
              <CourseWebDesignFirstCard />
              <CourseWritingFirstCard />
              <CourseMarketingFirstCard />
            </div>
            <div styleName="title">選択コース</div>
            <div styleName="sub-title">なりたい姿に合わせて追加で受けておきたいコース</div>
            <div styleName="pattern-bg">
              <img src={PatternLeft} styleName="pattern-left" />
              <img src={PatternRight} styleName="pattern-right" />
              <div styleName="pattern">
                <div styleName={classNames('label', 'popular')}>先輩シーメイトたちの受講パターン</div>
              </div>
              <div styleName="pattern-intro">
                <span styleName={classNames('marker', 'popular')}>パターン1</span>
                <span styleName="pattern-text">まずはSHElikesの人気コースから好きなことや向いていることを探したい</span>
              </div>
            </div>

            <div styleName="pattern-box">
              <p styleName="pattern-num">パターン1</p>
              {GlobalStatesV3.viewport.isSp && (
                <p styleName={classNames('pattern-label', 'popular')}>
                  まずはSHElikesの人気コースから好きなことや向いていることを探したい
                </p>
              )}
              <div styleName="pattern-detail-box">
                {GlobalStatesV3.viewport.isNonSp && (
                  <p styleName={classNames('pattern-label', 'popular')}>
                    まずはSHElikesの人気コースから好きなことや向いていることを探したい
                  </p>
                )}
                <p styleName="description sp-space">
                  Webデザイン、マーケティング、ライティングの基礎知識を学び、自分の得意や興味を探りながら、各分野への理解を深めていきます。並行してセルフブランディングのコースを受講し、自分がどうありたいのか・どう見せたいのかを考え、一緒にお仕事をしたい人や商品・サービスを届けたい人との共通認識を持てるようにしていきます。
                </p>
                <div styleName="intro-images">
                  <div>
                    <div styleName="sp-space">
                      <div styleName="pattern-title">COURSES</div>
                      <div styleName="sub-title">おすすめ受講コース</div>
                    </div>
                    <div styleName="small-course-area">
                      <CourseSmallSelfBrandingCard />
                    </div>
                  </div>
                  <div styleName="sp-space">
                    <div styleName="pattern-title">ROLE MODEL STORIES</div>
                    <div styleName="sub-title">先輩シーメイトインタビュー</div>
                    <div styleName="role-model-img">
                      <a href="https://shelikes.jp/shares/posts/4930159" target="_blank">
                        <img styleName="role-model-card" src={RoleModelCard1} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
